import { fetchRetry } from '@/utils/api/fetchRetry';

/**
 * @author Alejandro
 * @description Get the player seasons by his id and team class
 * @param {Object} params
 * @param {number} params.teamClass
 * @param {string} params.playerId
 * @return {Promise}
 */
export async function getSeasonsByPlayer({ teamClass, playerId }) {
  try {
    const url = `https://g2gwrzv5oe.execute-api.us-west-2.amazonaws.com/prod/seasonsByPlayer/${
      teamClass === 1 ? 1 : 0
    }/${playerId}`;
    const response = await fetchRetry({ url: url });
    return response.data.seasons;
  } catch (e) {
    return Promise.reject(e);
  }
}

/**
 * @author Alejandro
 * @description Get player's info by seasonId and playerId
 * @param {Object} params
 * @param {number} params.seasonId
 * @param {number} params.playerId
 */
export async function getPlayerInfo({ seasonId, playerId }) {
  try {
    const url = `https://0b6i026nwg.execute-api.us-west-2.amazonaws.com/prod/playerInfo/${seasonId}/${playerId}`;
    const response = await fetchRetry({ url: url });
    return response.data;
  } catch (e) {
    return Promise.reject(e);
  }
}

/**
 * @author Alejandro
 * @description Fetch player's info and seasons
 * @param {Object} params
 * @param {number} params.seasonId
 * @param {number} params.playerId
 */
export async function getPlayerInfoAndSeasons({ seasonId, playerId }) {
  try {
    // v2: https://uof4tt5l46.execute-api.us-west-2.amazonaws.com/prod/v2/playerInfo/
    const { data } = await fetchRetry({
      url: `https://uof4tt5l46.execute-api.us-west-2.amazonaws.com/prod/v3/playerInfo/${seasonId}/${playerId}`,
    });
    return data;
  } catch (e) {
    throw new Error(e);
  }
}

/**
 * @author Alejandro
 * @description Get player's statistics from the server.
 * @param {Object} params
 * @param {number} params.seasonId
 * @param {number} params.playerId
 */
export async function getPlayerStatisticsBySeason({ seasonId, playerId }) {
  try {
    const url = `https://fn0z0dd0u3.execute-api.us-west-2.amazonaws.com/prod/statsPlayerBySeason/${seasonId}/${playerId}`;
    return await fetchRetry({ url: url });
  } catch (e) {
    return Promise.reject(e);
  }
}

/**
 *
 * @param {Object} params
 * @param {(number|string)} params.seasonId
 * @param {(number|string)=} params.teamId
 * @return {Promise}
 */
export async function getPlayersBySeasonAndTeam({ seasonId, teamId }) {
  try {
    const url = `https://pa3kubpuhg.execute-api.us-west-2.amazonaws.com/prod/playersByTeamAndSeason/${seasonId}/${teamId ||
      ''}`;
    return await fetchRetry({ url: url });
  } catch (e) {
    return Promise.reject(e);
  }
}

/**
 * @author Alejandro
 * @param {Object} params
 * @param {(number|string)} params.seasonId
 * @param {(number|string)} params.playerId
 * @return {Promise}
 */
export async function getGoalsPlayerBySeason({ seasonId, playerId }) {
  try {
    const url = `https://lktcjrffmb.execute-api.us-west-2.amazonaws.com/prod/goalsPlayerBySeason/${seasonId}/${playerId}`;
    return await fetchRetry({ url: url });
  } catch (e) {
    return Promise.reject(e);
  }
}
